import {axiosInstanceWithToken}  from "../utils/Client";

export default class KPIReportService {

    static getKPIReport = (locationId, startDate, endDate) => {
        const url = `/kpi_report/${locationId}/?start_date=${startDate}&end_date=${endDate}`;
        return axiosInstanceWithToken.get(url);
    };

    static getDepartment = async (locationId) => {
        return await axiosInstanceWithToken.get(`/agency_departments/${locationId}/`);
    };
    
    static getLocationCount = () => {
        return axiosInstanceWithToken.get(`/location/count/`);
    };

    static getSelectedDeptList = async (locationId) => {
        return await axiosInstanceWithToken.get(`/selected_department/${locationId}/`);
    };

    static putSelectedDeptList = async (locationId, selectedDeptObj) => {
        return await axiosInstanceWithToken.put(
            `/selected_department/${locationId}/`, selectedDeptObj
        );
    };

    static getPDF = async (locationId, data) => {
        return await axiosInstanceWithToken.post(`/kpi_report/pdf/${locationId}/`, data);
    };
}



// WEBPACK FOOTER //
// ./src/services/AgencyKPIReportService.js